import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100" aria-label="精选推荐">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">编辑精选，品质保证</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {featuredMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[2/3] mb-3">
                <img
                  src={movie.image}
                  alt={`屁屁影院 - ${movie.title}`}
                  title={`屁屁影院${movie.title}在线观看`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-xs leading-relaxed line-clamp-3">{movie.description}</p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                {movie.tags.map((tag) => (
                  <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}